// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".equipment-image-view-modal .group-edit-image {\n  width: 600px !important;\n}\n.equipment-image-view-modal .open-link-container {\n  text-align: center;\n}\n.equipment-image-view-modal .open-link {\n  cursor: pointer;\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
